import {
  Container,
  Grid,
  ThemeProvider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ITheme, theme } from "../constants/theme";

import React, { ReactNode } from "react";
import { Stamp } from "../components-atoms";
import BackButton from "../components-atoms/BackButton";

export interface IHeaderWithButtonProps {
  fullWidthTitle: boolean;
  noButton: boolean;
  handleBack: () => void;
  smallText: string;
  title: string;
  children: ReactNode;
  shopDetailTitleMoreSpacing?: boolean;
  isShopInactive?: boolean;
  titleXs?: number;
}

export const ButtonArea = ({ children, style }: { children?: React.ReactNode, style?: React.CSSProperties }) => {
  const classes = useStyles();
  return (
    <Grid
      item
      justifyContent="flex-end"
      alignItems="center"
      container
      className={classes.headerButtonContainer}
      xs={12}
      style={style}
    >
      {children ? children : <></>}
    </Grid>
  );
};

export const HeaderWithButtons = (props: Partial<IHeaderWithButtonProps>) => {
  const { fullWidthTitle, isShopInactive, titleXs } = props;
  const classes = useStyles();

  return props?.noButton ? (
    <Container className={classes.header}>
      <ThemeProvider theme={theme}>
        <Grid container direction="row">
          {props?.handleBack && (
            <Grid xs={1} item container>
              <Grid
                item
                container
                alignItems="center"
                justifyContent="center"
                xs={12}
              >
                <BackButton onClick={props?.handleBack ? props.handleBack : () => { }} />
              </Grid>
            </Grid>
          )}
          <Grid
            item
            xs={props.shopDetailTitleMoreSpacing ? 7 : 5}
            className={classes.headerOrderDetailSection}
          >
            {props?.smallText && props?.smallText.trim() !== "" && (
              <Grid item>
                <Typography
                  variant="body1"
                  component="p"
                  color="textSecondary"
                  className={classes.headerSubtitle}
                >
                  {props.smallText}
                </Typography>
              </Grid>
            )}
            <Grid item style={{ display: "flex" }}>
              <Typography variant="h5" component="h1" color="textPrimary">
                {props?.title}
              </Typography>
              {isShopInactive && <Stamp type="fail" text="Inactive" />}
            </Grid>
          </Grid>

          <Grid
            item
            justifyContent="flex-end"
            alignItems="center"
            container
            className={classes.headerButtonContainer}
            xs={1}
          ></Grid>
        </Grid>
      </ThemeProvider>
    </Container>
  ) : (
    <div className={classes.header}>
      <ThemeProvider theme={theme}>
        <Grid container direction="row" justifyContent="space-between">
          {props?.handleBack && (
            <Grid xs={1} item container>
              <Grid item container alignItems="center" justifyContent="center">
                <BackButton onClick={props?.handleBack ? props.handleBack : () => { }} />
              </Grid>
            </Grid>
          )}
          <Grid
            item
            xs={props?.handleBack ? 11 : 12}
            className={classes.headerOrderDetailSection}
          >
            <Grid container direction="row">
              <Grid item
                // @ts-ignore
                xs={titleXs ? titleXs : fullWidthTitle ? 12 : 5}>
                <Grid item>
                  <Typography
                    variant="body1"
                    component="p"
                    color="textSecondary"
                    className={classes.headerSubtitle}
                  >
                    {props.smallText}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="h5" component="h1" color="textPrimary">
                    {props.title}
                  </Typography>
                </Grid>
              </Grid>
              {/* @ts-ignore */}
              <Grid xs={titleXs ? 12 - titleXs : fullWidthTitle ? 12 : 7} item container>
                {props.children}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ThemeProvider>
    </div>
  );
};

HeaderWithButtons.ButtonArea = ButtonArea;
const useStyles = makeStyles((theme: ITheme) => ({
  header: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  headerOrderDetailSection: {
    /* paddingLeft: "24px" */
  },
  headerSubtitle: {
    marginBottom: 4,
  },
  headerButtonContainer: {
    paddingRight: 0,
    padding: 0,
    margin: 0,
    marginRight: 0,
  },
  rejectButton: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.main,
    textTransform: "none",
    paddingRight: 16,
    paddingLeft: 12,
  },
  rejectButtonText: {
    textTransform: "none",
  },
  buttonIcon: {
    width: 18,
    height: 18,
    paddingRight: 5,
  },
  uPaddingLeft24: {
    paddingLeft: 24,
  },
}));
